/* global axios */
import ApiClient from './ApiClient';

class IvrAudiosAPI extends ApiClient {
  constructor() {
    super('ivr/audios', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/ivr/audios
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/ivr/audios/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/ivr/audios
  create(data) {
    return axios.post(this.url, { ivr_audio: data });
  }

  // PATCH /api/v1/accounts/:account_id/ivr/audios/:id
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { ivr_audio: data });
  }

  // DELETE /api/v1/accounts/:account_id/ivr/audios/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/ivr/audios/:id/regenerate
  regenerate(id) {
    return axios.post(`${this.url}/${id}/regenerate`);
  }

  // POST /api/v1/accounts/:account_id/ivr/audios/upload
  upload(formData) {
    return axios.post(`${this.url}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new IvrAudiosAPI();
